import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function ReactNative() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="React">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">Hire React Native Developers
</h2>
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">Hire React Native Developers At Dave's Brother Technology</h1>
      <p class="lg:w-2/3 mx-auto leading-relaxed text-base">Get help from Dave's  to hire seasoned React Native Developers, programmers, and techies and utilize their advanced skills to create the apps of the future. Our teams of carefully chosen React Native Developers are proficient in business applications, communications, and working in cross-functional teams.</p>
    </div>
    <div class="flex flex-col text-center w-full mb-20">
     
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Why Choose Dave's  For React Native Developers?
</h1>
     
    </div>
    <div class="flex flex-wrap">
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">24x7 Unwavering Support</h2>
        <p class="leading-relaxed text-base mb-4">Fretting about loading time issues? Don't worry! Our React Native Developers will be available to resolve any errors and problems for you instantaneously.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Flexible Hiring</h2>
        <p class="leading-relaxed text-base mb-4">Need React Native Developers for a single project? On Dave's Brother Technology, you can hire a team of developers that will be committed to your project until its completion. What's more? You can vary your team size according to your needs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Save Time & Money</h2>
        <p class="leading-relaxed text-base mb-4">You don't need to break your bank to hire React Native Developers anymore. Dave's  smoothens the hiring process for you - It's economical and best suited for startups/SMEs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Customer Is King!</h2>
        <p class="leading-relaxed text-base mb-4">You are our priority. We are resilient about the service we provide and make sure you get to work with the best React Native Developers</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
    </div>
    
  </div>
</section>

<section class="text-gray-600 body-font">
    <div class="flex flex-col text-center w-full mb-20">
     
     <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Benefits Of Choosing React Native Developers For Your Company

</h1>
    
   </div>
  <div class="container px-5 py-24 mx-auto flex flex-wrap">
    <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
      <img alt="feature" class="object-cover object-center mt-20-px h-300 w-300" src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"/>
    </div>
    <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp; Low Development Cost
</h2>
          <p class="leading-relaxed text-base text-gray-900">React Native Frameworks focuses on running codes on multiple platforms. Hence, the Mobile App Development becomes cheaper as compared to other development approaches.</p>
          
        </div>
      </div>

      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp; Live Updates</h2>
          <p class="leading-relaxed text-base text-gray-900">Live update is the reason that makes React Native sustain in the market. As React Native can push the updates to the user’s phone without following the app store update cycle. Hence, users can enjoy the updated versions of the app instantly.</p>
          
        </div>
      </div>

      
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Stability</h2>
          <p class="leading-relaxed text-base text-gray-900">The behavior of customers on your app is a great way to gain insight into what they want. You can then devise a new product or service that caters to this demand, or make changes to serve your consumers better.</p>
         
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Great User Experience</h2>
          <p class="leading-relaxed text-base text-gray-900">React Native apps provides a good UI and UX which eventually leads to user satisfaction. Hire React Native app developers from EngineerBabu to build an exceptional cross-platform mobile app.</p>
          
        </div>
      </div>
      
    </div>
  </div>
</section>
<Footer />
    </>
  );
}